//
//
//
//

import RbPayOverTimeContent from '@/elements/pay-over-time/rb-pay-over-time-content.vue'

export default {
  name: 'rb-pay-over-time-panel',
  components: {
    RbPayOverTimeContent,
  },
}
